import React, { useState } from 'react';
export function NewsletterSection() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter signup
    console.log('Newsletter signup:', email);
  };
  return <section className="w-full bg-[#f5f1ed] py-12 lg:py-16" data-id="element-270">
      <div className="max-w-5xl mx-auto px-6 lg:px-12" data-id="element-271">
        {/* Decorative top border */}
        <div className="w-24 h-1 bg-[#496f58] mx-auto mb-8 rounded-full" data-id="element-272"></div>

        <div className="bg-[#496f58] rounded-3xl shadow-2xl p-6 lg:p-10" data-id="element-273">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center" data-id="element-274">
            {/* Left: Heading */}
            <div className="text-center lg:text-left" data-id="element-275">
              <h2 className="font-serif text-3xl lg:text-4xl font-bold text-white mb-3" data-id="element-276">
                Keep in touch
              </h2>
              <p className="text-white/90 text-base" data-id="element-277">
                Weekly encouragement for the overwhelmed Christian & get first access to new products and subscriber-only savings.
              </p>
            </div>

            {/* Right: Email Form */}
            <div data-id="element-278">
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3" data-id="element-279">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" required className="flex-1 px-5 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white/50" data-id="element-280" />
                <button type="submit" className="bg-white hover:bg-gray-50 text-[#496f58] font-bold px-6 py-3 rounded-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap" data-id="element-281">
                  SIGN UP
                </button>
              </form>

              <p className="text-white/70 text-xs mt-3 leading-relaxed text-center sm:text-left" data-id="element-282">
                We respect your privacy. By clicking "Sign Up" you consent to
                our{' '}
                <a href="#" className="underline hover:text-white" data-id="element-283">
                  Privacy Policy
                </a>
                .
              </p>
            </div>
          </div>
        </div>

        {/* Decorative bottom border */}
        <div className="w-24 h-1 bg-[#496f58] mx-auto mt-8 rounded-full" data-id="element-284"></div>
      </div>
    </section>;
}